// extracted by mini-css-extract-plugin
module.exports = {"sp-160w-single":"SP160wSingle_sp-160w-single___Z7yJ"};